"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.8806 8.111-.7284-.7284 2.1005-2.1005-1.4143-1.4142-2.1004 2.1005-.7072-.7071 2.1005-2.1005-1.4142-1.4142-2.1005 2.1004-.6858-.6858-12.728 12.728.686.6858-2.1422 2.1422 1.4142 1.4142 2.1421-2.1422.7072.7071-2.1422 2.1422 1.4142 1.4142 2.1422-2.1422.7283.7284 12.728-12.728zM6.0313 15.8892l2.1213 2.1213 1.4142-1.4142-2.1214-2.1213-1.414 1.4142zm9.1924-4.9498-4.2427 4.2427-2.1213-2.1213 4.2427-4.2427 2.1213 2.1213zm1.4142-1.4142 1.4142-1.4142-2.1213-2.1213-1.4142 1.4142 2.1213 2.1213z"
  })];
};

exports.default = _default;